import {Component, Input} from "@angular/core";
import {OnfidoReport} from "../../../api/entity/identity-verification";

@Component({
    selector: 'tfl-bo-onfido-verification-report',
    template: `
        <div class="row">
            <div class="col-xs-3">
                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_ID' | translate }}:</b>
            </div>
            <div class="col-xs-9">{{ report.id }}</div>
        </div>
        <div class="row">
            <div class="col-xs-3">
                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_NAME' | translate }}:</b>
            </div>
            <div class="col-xs-9">{{ report.name }}</div>
        </div>
        <div class="row">
            <div class="col-xs-3">
                <b>{{ 'CUSTOMER.VERIFICATION.BLOCK.FIELD.REPORT_CREATED_AT' | translate }}:</b>
            </div>
            <div class="col-xs-3">{{ report.createdAt }}</div>
        </div>

        <h6>{{ 'CUSTOMER.VERIFICATION.BLOCK.TITLE.BREAKDOWN' | translate }}:</h6>
        
        <div class="row">
            <tfl-bo-onfido-verification-report-breakdown [breakdown]="report.breakdown">
            </tfl-bo-onfido-verification-report-breakdown>
        </div>
    `
})
export class ReportOnfidoVerificationComponent {

    @Input() report: OnfidoReport;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/results/report.onfido.verification.component.ts